export const formPhoneNumberFieldStyles = {
	root: {
		width: '100%',
		display: 'grid',
		gridTemplateColumns: {
			xs: '1fr',
			sm: 'min-content 1fr'
		},
		alignItems: 'center',
		gap: 1
	},

	label: {
		pt: 1,
		height: '100%',
		minWidth: 200,
		typography: 'subtitle1',
		color: 'text.primary',
		userSelect: 'none',
		fontWeight: '700',
		pointerEvents: 'none'
	},

	fieldWrap: {
		position: 'relative'
	}
};
